"use client"

import Image from 'next/image'
import Link from 'next/link'
import { Button } from '../shadcn/button'
import { useState } from 'react'
import VideoPopin from './VideoPopin'
import { ChevronLeft, ChevronRight, Play } from 'lucide-react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { useModal } from '../context/ModalContext'
import { useAuth } from '../context/AuthContext'
import LoginModal from '../context/modals/Login'

export default function HomepageHero({ datas }: { datas: any }) {
	const [isVideoOpen, setIsVideoOpen] = useState(false)
	const [currentSlide, setCurrentSlide] = useState(0)
	const { openModal, closeModal } = useModal()
	const { user } = useAuth()

	const handleVideoClick = (index: number) => {
		setCurrentSlide(index)
		setIsVideoOpen(true)
	}

	return (
		<>
			<div className="container flex flex-col lg:flex-row gap-5 my-3">
				<div className="lg:flex-[3] shrink-0 overflow-hidden relative">
					<Swiper
						modules={[Pagination, Autoplay, Navigation]}
						spaceBetween={30}
						slidesPerView={1}
						navigation={{
							nextEl: '.hero-button-next',
							prevEl: '.hero-button-prev',
						}}
						pagination={{ clickable: true }}
						autoplay={{
							delay: 5000,
							disableOnInteraction: false,
						}}
						loop={true}
						className={`h-[240px] lg:h-full rounded-none lg:rounded-3xl ${datas.slides.length <= 1 ? 'no-dots' : ''}`}
						breakpoints={{}}
					>
						{datas.slides.map((slide: any, index: number) => (
							<SwiperSlide key={index}>
							<div 
								className="p-4 h-full overflow-hidden relative bg-cover bg-center cursor-pointer group" 
								style={{ backgroundImage: `url('${slide?.videoImage?.s3Url || ''}')` }}
								onClick={() => handleVideoClick(index)}
							>
								<span className="bg-white/40 p-4 rounded-full shadow-lg group-hover:top-[calc(50%-2px)] transition-all absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
									<Play className="w-10 h-10 text-white" />
								</span>

								<div className="absolute top:unset md:top-1/2 bottom-0 md:bottom-unset left-0 md:left-2 lg:left-10 translate-y-0 md:-translate-y-1/2 h-unset md:h-3/4 w-full md:w-2/3 lg:w-1/3 bg-black/60 p-4 lg:p-6 z-10 flex flex-col gap-4 items-start justify-center rounded-none md:rounded-md shadow-lg">
									<h2 className="text-sm leading-tight lg:text-2xl font-bold font-alt text-white relative z-10">
										{slide?.title}
									</h2>
									<p className="text-white text-xs lg:text-sm font-alt relative z-10">
										{slide?.description}
									</p>
								</div>
							</div>
							</SwiperSlide>
						))}
					</Swiper>
					<div className="hero-button-prev hidden lg:block absolute top-1/2 -left-2 -translate-y-1/2 z-10 cursor-pointer">
						<ChevronLeft className="w-12 h-12 text-primary" />
					</div>
					<div className="hero-button-next hidden lg:block absolute top-1/2 -right-2 -translate-y-1/2 z-10 cursor-pointer">
						<ChevronRight className="w-12 h-12 text-primary" />
					</div>
				</div>
				<div className="lg:flex-[2] shrink-0 flex flex-col-reverse lg:flex-col gap-4">
					<div className="bg-dark px-8 py-3 rounded-3xl flex gap-3 items-center">
						<Image
							src={
								'https://res.cloudinary.com/dr04tcjag/image/upload/v1741485266/whatsapp_egnfsn.svg'
							}
							alt="dundshop logo"
							width={40}
							height={40}
						/>
						<div className="flex flex-col text-white">
							<p className="text-md font-light">{datas.whatsappText}</p>
							<a href="tel:+33623962343" className="font-extrabold text-md">
								{datas.whatsappNumber}
							</a>
						</div>
					</div>
					<div className="bg-hp_mea py-8 px-5 rounded-3xl flex items-center gap-4">
						<div className="flex flex-col items-start py-4 text-black gap-3 w-full lg:w-1/2">
							<p className="text-4xl">{datas.pushTitle}</p>
							<p className="text-md font-light">{datas.pushDescription}</p>
							<Link href={datas.pushLink || '#'}>
								<Button size={'lg'}>{datas.pushCta}</Button>
							</Link>
							{user ? (
								<Link href="/product/create" className="lg:hidden">
									<Button size={'lg'} variant="optional">Vendez des articles</Button>
								</Link>
							) : (
								<Link
									href="#"
									className="lg:hidden"
									onClick={(e) => {
										e.preventDefault()
										openModal(<LoginModal closeAction={closeModal} />)
									}}
								>
									<Button size={'lg'} variant="optional">Vendez des articles</Button>
								</Link>
							)}
						</div>
						<div className="w-1/2 hidden lg:flex items-center justify-center">
							<img
								src={ `${datas.pushImage?.s3Url || ''	}` }
								alt={ `${datas.pushImage?.alt}` }
								className="max-w-full"
							/>
						</div>
					</div>
				</div>
			</div>
			<VideoPopin 
				isOpen={isVideoOpen} 
				closeAction={() => setIsVideoOpen(false)} 
				currentSlide={currentSlide}
				slides={datas.slides}
			/>
		</>
	)
}
